import { render, staticRenderFns } from "./IconCheque.vue?vue&type=template&id=ee6347c2&"
import script from "./IconCheque.vue?vue&type=script&lang=js&"
export * from "./IconCheque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports